<template>
  <div>
    <AppPreloader v-if="!fetched || company.isFetching" />
    <template v-else>
      <div v-if="error">
        {{ error }}
      </div>
      <div v-else />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { candidateStatuses } from '@/enums';
import AppPreloader from '../components/AppPreloader.vue';

export default {
  name: 'CandidatePersonalLink',
  components: {
    AppPreloader,
  },
  metaInfo() {
    return {
      title: 'Huntica',
    };
  },
  props: {
    hashId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      fetched: false,
    };
  },
  computed: {
    ...mapState('candidate', {
      candidate: state => state.data.candidate,
      vacancy: state => state.data.vacancy,
    }),
    ...mapState('company', ['company', 'vacancies']),
  },
  async mounted() {
    await this.fetch();
  },
  created() {
    this.calculateHeight();
  },
  methods: {
    // eslint-disable-next-line consistent-return
    async fetch() {
      try {
        await this.$store.dispatch('candidate/loginByHashId', {
          hashId: this.hashId,
          vacancyId: this.vacancy.id,
        });
        await this.$store.dispatch('candidate/fetchData', { vacancyId: this.vacancy.id });
        await this.$store.dispatch('company/fetchCompany', this.vacancy.companyId);

        if (this.company?.data?.companyTemplateSettings
          && this.$route?.query?.preview !== 'true'
          && this.$route.name !== 'iframeCandidateInviteLink') {
          window.location.href = `${process.env.VUE_APP_CAREER_PORTAL_URL}/${this.company.data.id}/vacancies/${this.vacancy.id}/reply/${this.hashId}`;
          return;
        }

        this.fetched = true;

        this.redirectCandidate();
      } catch (e) {
        if (e.name === 'ApiError') {
          return this.$router.push({ name: '404' });
        }
        this.error = e.message;
      }
    },
    redirectCandidate() {
      if (this.candidate.status === candidateStatuses.IMPORTED && !this.candidate.interview) {
        localStorage.setItem('interviewStep', 2);
        return this.$router.push({
          name: 'interviewIframe',
          params: {
            companyId: this.vacancy.companyId,
            vacancyId: this.vacancy.id,
            step: 2,
          },
        });
      }

      if (this.candidate.status !== candidateStatuses.INVITED
        && this.candidate.status !== candidateStatuses.IMPORTED) {
        return this.$router.push({
          name: 'iframeInterviewResult',
          params: {
            companyId: this.vacancy.companyId,
            vacancyId: this.vacancy.id,
            hashId: this.hashId,
          },
        });
      }

      if (this.candidate.interview) {
        return this.$router.push({
          name: 'iframeInterviewContinue',
          params: {
            companyId: this.vacancy.companyId,
            vacancyId: this.vacancy.id,
            hashId: this.hashId,
          },
        });
      }

      return window.parent.postMessage('redirect:vacancyReply', '*');
    },
    calculateHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          let height = document.documentElement.scrollHeight;
          if (document.documentElement.offsetHeight > height) {
            height = document.documentElement.offsetHeight;
          }
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage({ height }, '*');
        }, 1000);
      });
    },
  },
};
</script>
